export default __webpack_public_path__ + "static/media/196.c87b5cc0.gif";